// extracted by mini-css-extract-plugin
export default {"container":"HeaderOnly_container__bk2ml","header":"HeaderOnly_header__TrQQ5"};